// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".opacity-admin-bg[data-v-732ca174]{border-radius:3px;padding:3px;background-color:rgba(115,94,80,.85)}section[data-v-732ca174]{position:absolute;z-index:10;display:flex;align-items:center}button[data-v-732ca174]{border-radius:2px;padding:6px 10px;margin:0;border:0}.StyleSelector-font[data-v-732ca174]{width:200px;margin-right:-7px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
